export default __webpack_public_path__ + "static/ak-cached/24h/media/mob-seamless_header-move.1038eb81.jpg";